import { render, staticRenderFns } from "./Inspect.vue?vue&type=template&id=20e75a5c"
import script from "./Inspect.vue?vue&type=script&lang=js"
export * from "./Inspect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports